<template>
    <div
        class="md-hero layout11 banner-with-search-group mg-bg"
        :style="{
            ...colorStyle,
            ...spaceStyle
        }"
    >
        <banner
            ref="banner"
            :type="type"
            :mobileType="mobileType"
            :useMobileSettings="useMobileSettings"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :mobilePicture="mobilePicture"
            :pictureListOption="pictureListOption"
            :mobilePictureListOption="mobilePictureListOption"
            :maskOption="maskOption"
            :videoOption="videoOption"
            :mobileVideoOption="mobileVideoOption"
            :rawDot="true"
            :getBannerStyle="getBannerStyle"
        >
            <media-content
                :class="`media-content-${searchStyle}`"
                :type="contentType"
                :title="title"
                :subTitle="subTitle"
                :showShadow="showShadow"
                :layout="searchBarLayout"
                class="row2column"
                v-animated="{name: 'appear-down', enable: showAnimationEffects}"
            >
                <template #info>
                    <div v-if="useType === 'video'" class="play-video"></div>
                </template>
                <div v-if="useType === 'video'" class="video-loading"></div>
                <div class="media-content-box" @click="avoidEmitMedia">
                    <search-group
                        :needSearchCondition="false"
                        :searchGroupTabs="searchGroupTabList"
                        :searchGroupConfig="searchGroupConfig"
                        :nameType="nameType"
                        :nameRequired="nameRequired"
                        :phoneRequired="phoneRequired"
                        :agreementData="agreementData"
                        :searchButton="searchButton"
                    />
                </div>
            </media-content>
        </banner>
    </div>
</template>

<script>
import common from '../index.js';
import mixinsSearchBar from './mixins-search-bar.js';
import MediaContent from '../../../components/media-content-v2.vue';
import SearchGroup from './search-group.vue';
export default {
    data: function() {
        return {
            priceInterval: [0, [20, 10000], [32, 25000], [90, 100000]]
        };
    },
    mixins: [common, mixinsSearchBar],
    components: {
        MediaContent,
        SearchGroup
    }
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-hero.layout11 {
    --swiper-pagination-bottom: 30px;
    .video-box video {
        object-fit: cover;
    }
    .banner-video {
        .play-video {
            display: none;
        }
        .video-loading {
            display: none;
        }
    }
    .banner {
        align-items: flex-end;
        padding-bottom: 100px;
    }

    .media-content-v2 {
        position: static;
        padding: 0 50px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        row-gap: 160px;
        z-index: 10;
        box-sizing: border-box;
        .media-info {
            width: 100%;
            .title-text {
                width: 100%;

                .site-subtitle {
                    margin-top: 30px;
                }
            }
        }
        .media-content-box {
            width: 1000px;
            max-width: 100%;
        }
    }
    .banner-video + .media-content-v2 {
        .play-video {
            width: 64px;
            height: 64px;
            border: 1px solid white;
            border-radius: 50%;
            margin: 20px auto;
            cursor: pointer;
            pointer-events: all;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            &:after {
                content: '';
                position: absolute;
                top: 50%;
                left: 26px;
                transform: translateY(-50%);
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
                border-left: 14px solid white;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
                position: relative;
                left: 0;
                top: 0;
                transform: translate(0, 0);
                &:after {
                    left: 15px;
                    border-top: 5px solid transparent;
                    border-bottom: 5px solid transparent;
                    border-left: 10px solid white;
                }
            }
        }
        .video-loading {
            display: none;
            width: 108px;
            height: 108px;
            background: url(//static.chimeroi.com/site/images/home/loading.gif)
                no-repeat;
            background-size: cover;
            @include media-1080 {
                width: 60px;
                height: 60px;
            }
            @include media-600 {
                width: 40px;
                height: 40px;
            }
        }
    }
    .banner-video.autoplay + .media-content-v2,
    .banner-video.is-play + .media-content-v2 {
        .video-loading {
            display: none;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.loading + .media-content-v2 {
        .video-loading {
            display: block;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.is-play ~ .banner-mask {
       // display: none;
    }

    @include media-800 {
        .banner {
            align-items: center;
            padding-bottom: 10px;
            .banner-mask{
                pointer-events: auto;
            }
        }
        .media-content-v2 {
            padding: 0 15px;
            flex-direction: column;
            row-gap: 30px;
            .media-info {
                width: 100%;
                .title-text {
                    .site-subtitle {
                        margin-top: 15px;
                    }
                }
            }
            .media-content-box {
                width: 100%;
            }
        }
    }
}
</style>
